<div class="support-modal-main d-flex flex-column">
  <div class="header">
    <div class="header-content">
      <div class="back-btn-wrapper" (click)="onBack()">
        <img
          src="/assets/svg/ico-chevron-back-outline.svg"
          class="back-icon pointer-cursor"
          alt="Back"
        />
      </div>
      <h2 class="title-text">
        {{
          (currentView === 'call' ? 'CALL_SUPPORT' : 'SUPPORT') | translate
        }}
      </h2>
      <div (click)="closeDialog()" class="close-btn-wrapper">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="close-icon pointer-cursor"
          alt="Close"
        />
      </div>
    </div>
  </div>

  <div class="content-container" *ngIf="currentView === 'main'">
    <h3 class="section-label">{{ 'HELP_RESOURCES' | translate }}</h3>
    <div class="action-items-card">
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getFaqSupportVideosLink())"
      >
        <span class="action-text">{{ 'FAQS_AND_SUPPORT_VIDEOS' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getSoftwareUserGuideLink())"
      >
        <span class="action-text">{{ 'SOFTWARE_USER_GUIDE' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getQuickReferenceGuideLink())"
      >
        <span class="action-text">{{ 'QUICK_REFERENCE_GUIDE' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getReleaseNotesLink())"
      >
        <span class="action-text">{{ 'RELEASE_NOTES' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
    </div>

    <h3 class="section-label">{{ 'CONTACT' | translate }}</h3>
    <div class="action-items-card">
      <div class="action-item pointer-cursor" (click)="showCallSupport()">
        <span class="action-text">{{ 'CALL_SUPPORT' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        *ngIf="showEmailSupport"
        (click)="openEmailSupport()"
      >
        <span class="action-text">{{ 'EMAIL_SUPPORT' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
    </div>

    <h3 class="section-label">{{ 'LEGAL' | translate }}</h3>
    <div class="action-items-card">
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getTermsOfServiceLink())"
      >
        <span class="action-text">{{ 'TERMS_OF_SERVICE' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getPrivacyPolicyLink())"
      >
        <span class="action-text">{{ 'PRIVACY_POLICY' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
      <div
        class="action-item pointer-cursor"
        (click)="openExternalLink(supportService.getMasterCredentialPolicyLink())"
      >
        <span class="action-text">{{ 'MASTER_CREDENTIAL_POLICY' | translate }}</span>
        <img
          src="/assets/svg/ico-chevron-forward-outline.svg"
          class="chevron-icon"
          alt=""
        />
      </div>
    </div>
  </div>

  <div class="content-container call-support-view" *ngIf="currentView === 'call'">
    <div class="call-support-card">
      <h3 class="call-support-heading">
        <span class="heading-line">
          {{
            'CONTACT_CUSTOMER_SERVICE_LINE1'
              | translate : { brand: brandDisplayName }
          }}<sup class="trademark">TM</sup>
        </span>
        <span class="heading-line">{{
          'CONTACT_CUSTOMER_SERVICE_LINE2' | translate
        }}</span>
      </h3>

      <ng-container *ngIf="!supportService.isWeiserBrand(); else weiserCallSupport">
        <a
          class="phone-link pointer-cursor"
          [href]="supportService.getSupportPhoneTel()"
          (click)="supportService.openSupportPhone(); $event.preventDefault()"
        >
          {{ 'SUPPORT_PHONE_NUMBER_KWIKSET' | translate }}
        </a>
        <div class="hours-block hours-block--kwikset">
          <p class="hours-text">{{ 'SUPPORT_DAYS_KWIKSET' | translate }}</p>
          <p class="hours-text">{{ 'SUPPORT_HOURS_KWIKSET' | translate }}</p>
        </div>
      </ng-container>

      <ng-template #weiserCallSupport>
        <a
          class="phone-link pointer-cursor"
          [href]="supportService.getSupportPhoneTel()"
          (click)="supportService.openSupportPhone(); $event.preventDefault()"
        >
          {{ 'SUPPORT_PHONE_NUMBER_WEISER' | translate }}
        </a>
        <div class="hours-block hours-block--weiser">
          <div class="hours-group">
            <p class="hours-text">{{ 'SUPPORT_WEEKDAYS_LABEL' | translate }}</p>
            <p class="hours-text">
              {{ 'SUPPORT_WEEKDAYS_HOURS_WEISER' | translate }}
            </p>
          </div>
          <div class="hours-group">
            <p class="hours-text">{{ 'SUPPORT_SATURDAY_LABEL' | translate }}</p>
            <p class="hours-text">
              {{ 'SUPPORT_SATURDAY_HOURS_WEISER' | translate }}
            </p>
          </div>
          <p class="hours-text">{{ 'SUPPORT_CLOSED_HOLIDAYS' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>
